import { UseQueryOptions } from '@tanstack/react-query';
import classNames from 'classnames';
import { stringify } from 'qs';
import { useEffect } from 'react';
import { EvolveToken, useEvolve } from '~/components/Evolve/Form/EvolveForm.hooks';
import hourglass from '~/components/Icon/hourglass.png';
import { Iframe } from '~/components/Iframe/Iframe';
import styles from './EvolveTfa.module.scss';

export type EvolveTfaProps = EvolveToken & {
  className?: string;
  onSuccess?: UseQueryOptions['onSuccess'];
  onError?: UseQueryOptions['onError'];
};
export const EvolveTfa = ({
  evolutionId,
  authUri,
  className,
  onSuccess,
  onError,
}: EvolveTfaProps) => {
  const { mutate } = useEvolve({
    onSuccess,
    onError,
  });
  const authSrc = `${authUri}?${stringify({ logout_url: `${location.origin}/auth/logout` })}`;

  useEffect(() => {
    window.onTfaVerified = () => {
      mutate({
        evolutionId,
        authUri,
      });
    };
    return () => (window.onTfaVerified = undefined);
  }, [authUri, evolutionId, mutate]);

  if (import.meta.env.STORYBOOK === 'true') {
    onSuccess?.(true);
  }

  return (
    <div className={classNames(styles.root, className)}>
      <Iframe
        src={authSrc}
        data-event="impression"
        data-event-category="evolve_passcode_popup"
        data-event-impression-id="{category}"
        className={styles.iframe}
      />
      <link rel="preload" as="image" href={hourglass} />
    </div>
  );
};
